import { filterColors, specialFilterColors } from './colorPalette';

export default function getColor(index, name) {
  // return if it's available in predefined colors
  const color = specialFilterColors.get(name);
  if (color) {
    return color;
  }

  const len = filterColors.length - 1 || 0;
  return filterColors[index % len];
}

function* generateColor() {
  const len = filterColors.length || 0;
  let index = 0;
  let name;
  while (true) {
    const color = specialFilterColors.get(name);
    if (color) {
      name = yield color;
    } else {
      name = yield filterColors[index % len];
      index += 1;
      if (index > filterColors.length) {
        index = 0;
      }
    }
  }
}

export { generateColor };
